import { render } from "./LoadingSpinner.vue?vue&type=template&id=91e67cd4&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=ts"
export * from "./LoadingSpinner.vue?vue&type=script&lang=ts"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=91e67cd4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-91e67cd4"

export default script